export enum AccessLevel {
    Account=1,
    Store=2,
    CMS=51,
    Customer_Service=61,
    Department=90,
    Pos_Event=92
}


// WEBPACK FOOTER //
// ./src/app/common/enums/access-level.enum.ts